import React, { useEffect, useState } from "react";

const TARGET = new Date("2026-09-25T15:30:00+02:00").getTime();

const diff = () => {
  const ms = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms / 3600000) % 24),
    minutes: Math.floor((ms / 60000) % 60),
    seconds: Math.floor((ms / 1000) % 60),
    done: ms === 0,
  };
};

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [t, setT] = useState(diff);

  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) {
    return (
      <div data-testid="eventinfo-countdown" className="mt-10 inline-flex items-center gap-3 rounded-full border border-[var(--crtr-yellow)]/50 px-5 py-2.5">
        <span className="h-2 w-2 animate-pulse rounded-full bg-[var(--crtr-yellow)]" />
        <span className="mono-label text-xs text-[var(--crtr-yellow)]">It’s happening – see you in Hallein</span>
      </div>
    );
  }

  const units = [
    ["Tage", t.days],
    ["Std", pad(t.hours)],
    ["Min", pad(t.minutes)],
    ["Sek", pad(t.seconds)],
  ];

  return (
    <div data-testid="eventinfo-countdown" className="mt-10 inline-flex flex-wrap items-end gap-3 rounded-2xl border border-white/10 bg-black/25 px-5 py-5 backdrop-blur-sm sm:gap-8 sm:px-6">
      <span className="mono-label w-full text-[10px] text-white/50 sm:w-auto sm:pb-2">Noch</span>
      {units.map(([label, value], i) => (
        <div key={label} className="flex items-end gap-3 sm:gap-8">
          <div className="text-left">
            <span className="font-display block text-[2rem] tabular-nums text-white sm:text-5xl" data-testid={`countdown-${label.toLowerCase()}`}>{value}</span>
            <span className="mono-label mt-1 block text-[10px] text-[var(--crtr-yellow)]">{label}</span>
          </div>
          {i < units.length - 1 && <span className="font-display pb-6 text-2xl text-white/25 sm:text-4xl">:</span>}
        </div>
      ))}
    </div>
  );
}
